import React from 'react'
import Hero from '../components/Hero/Hero'
import Features from '../components/Features/Features';
import { Team } from '../components/Team/Team';
import { heroTwo, heroThree } from '../data/HeroData';
import { Content1 } from '../components/Content/Content1';
import { Content2 } from '../components/Content/Content2';
import Footer from '../components/Footer/Footer';

export default function Home() {
  return (
    <>
    <Hero/>
    <Features />
    <Team inverse={true} />
    <Content1 {...heroTwo} />
		<Content2 {...heroThree} />
    <Footer />
    </>
  )
}
